<template>
  <div class="message">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="系统通知" name="first"></el-tab-pane>
      <el-tab-pane label="点赞" name="second"></el-tab-pane>
      <el-tab-pane label="留言" name="third"></el-tab-pane>
    </el-tabs>
    <div v-if='messageDetails'>
      <div v-if='dataEmpty'>
        <el-row v-for="(item,index) in messageList" :key="index">
          <!-- 0未读 1已读 -->
          <label v-if="item.is_read == 0" class="redLabel"></label>
          <!-- <el-col :span="3"><div class="grid-content left"></div></el-col> -->
          <el-col :span="24">
            <div class="grid-content right">
              <div  class="title yh"  @click="clickDetails(item.id)">
                {{item.title}}
              </div>
              <div class="time">{{item.created_at}}</div>
            </div>
          </el-col>
        </el-row>
        <pagination class="pages"  :listNum="listNum"></pagination>
      </div>
      <data-empty v-else></data-empty>
    </div>
    <message-details @childemit='backgo' :messageDetailList='messageDetailList' v-else></message-details>
  </div>
</template>
<script>
import pagination from "@/components/Pagination"
import DataEmpty from '@/components/Data'
import MessageDetails from "../components/MessageDetails"
export default {
  name: 'MessageList',
  components: {
    pagination,
    DataEmpty,
    MessageDetails
  },
  props: ['hasMessage'],
  data() {
    return {
        activeName: 'first',
        type:'1',
        listNum:0,
        messageList:{},
        page:1,
        page_size:12,
        dataEmpty:true,
        messageDetails:true,
        messageDetailList:''
    }
  },
  created(){
    this.getList(this.$data.page,this.$data.page_size)
  },
  mounted () {
    this.newMessage()
  },
  methods: {
      handleClick(tab, event) {
          switch (tab.name) {
              case 'first':
                  this.$data.type = '1';
                  break;
              case 'second':
                  this.$data.type = '2';
                  break;
              case 'third':
                  this.$data.type = '3';
                  break;
          }
          this.$api.myMessage({'type':this.$data.type}).then(res => {
              //数据处理
              console.log(res)
              if(res.data.message_list == ''){
                  this.dataEmpty = false
              }else{
                  this.dataEmpty = true
              }
              this.$data.messageList = res.data.message_list
              this.$data.listNum = parseInt(res.data.message_num)
          }).catch(err => console.log(err))
      },
      getList(page,page_size){
          var data = {
              type:this.$data.type,
              page:page,
              page_size:page_size,
          }
          this.$api.myMessage(data).then(res => {
              //数据处理
              if(res.data.message_list == ''){
                  this.dataEmpty = false
              }else{
                  this.dataEmpty = true
              }
              this.$data.messageList = res.data.message_list
              this.$data.listNum = parseInt(res.data.message_num)
          }).catch(err => console.log(err))
      },
      clickDetails(id){
        this.messageDetails = false
        this.$api.meaasgeDetails({id:id}).then(res => {
          if(res.code == 200){
            this.messageDetailList = res.data
          }
        }).catch(err=>console.log(err))
      },
      newMessage(){
        this.$api.newMessage().then(res => {
         // 1有已读 0 未读
          if(res.data.has_message == 0){
            this.$emit('hasMessage',0)
          }else if(res.data.has_message == 1){
            this.$emit('hasMessage',1)
          }
        }).catch(err=>console.log(err))
      },
      backgo(data){
        if(data){
          this.messageDetails = true
          this.getList(this.$data.page,this.$data.page_size)
          this.newMessage()
        }
      }
  }
}
</script>
<style scoped>
  .message{
    width: 100%;
    height: 100%;
    padding: 40px;
    box-sizing: border-box;

  }
  .el-row{
    margin-top: 40px;
    border-bottom: 1px solid #EEEEEE;
  }
  .left{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .grid-content img{
    width: 40px;
    height: 40px;
    background: #F6F6F6;
    border-radius: 50%;
  }
  .grid-content .title{
    /* height: 12px; */
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
  .grid-content .title:hover{
    color: #6BC96B;
    cursor: pointer;
  }
  .grid-content .time{
    height: 9px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-top: 10px;
  }
  .redLabel{
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 2.5px;
    background: red;
    position: absolute;
    left: -10px;
    top: 10px;
  }

  @media (min-width: 1024px){
      .el-row{
        padding-bottom: 40px;
      }
    } /*>=1024的设备*/

    @media (min-width: 1100px) {
    
    } /*>=1100的设备*/
    @media (min-width: 1280px) {
      .el-row{
        padding-bottom: 20px;
      }
      
    } /*>=1280的设备*/
 

</style>



// WEBPACK FOOTER //
// src/my/components/MessageList.vue